import { axiosInstance, live_instance } from "../instance";


/**======================================== 产品运营管理 ========================================================= */
// 获取下拉搜索的品牌产品
export const getCMSAgentApi = (params) => axiosInstance({ method: 'get', url: `/api/category/getCmsAgent` })

//添加主题
export const addThemeApi = data => {
  const { description, name, templateId, type, contentType, recommendType } = data
  return axiosInstance({
    method: 'post', url: '/api/vodplusTheme/addTheme',
    data: {
      description,
      name,
      templateId,
      type,
      contentType,
      recommendType
    },
    type: 'json'
  })
}

// 修改主题
export const editThemeApi = data => {
  const { description, name, templateId, type, id, contentType, recommendType } = data
  return axiosInstance({
    method: 'post', url: '/api/vodplusTheme/editTheme',
    data: {
      description,
      name,
      templateId,
      type,
      id,
      contentType,
      recommendType
    },
    type: 'json'
  })
}

// 修改推荐位尺寸类型
export const editRecommendedTypeApi = data => {
  return axiosInstance({ method: 'post', url: '/api/vodplusTheme/editRecommendedType', data, type: 'json' })
}

// 删除主题
export const deleteThemeApi = data => {
  const { id } = data
  return axiosInstance({ method: 'delete', url: '/api/vodplusTheme/deleteTheme', data: { id } })
}

// 获取我的产品
export const getCMSProductApi = params => axiosInstance({ method: 'get', url: '/api/category/getCmsProduct', params })

//获取主题列表
export const getTopicListApi = (params) => {
  return axiosInstance({ method: 'get', url: '/api/vodplusTheme/getThemeList', params })
}
//获取模板
export const getTemplateApi = (params) => {
  return axiosInstance({ method: 'get', url: '/api/vodplusTheme/getThemeTemplate', params })
}
//获取推荐位尺寸
export const getRecommendationApi = (params) => {
  return axiosInstance({ method: 'get', url: '/api/vodplusTheme/getThemeItemSize', params })
}

// 处理参数
const formatParams = (data) => {
  // 需要提交的字段
  let paramsKeys = ['pictureFile', 'agentCategory', 'cpmIds', 'cid', 'name', 'status', 'programType', 'language', 'protocolId', 'sequence', 'seriesPreviewCount', 'programPreviewMinute', 'remark', 'cids', 'pids', 'logoPath', 'adult', 'enterAddress', 'serverGroup', 'uiStyle']
  let formData = new FormData()
  for (let key in data) {
    if (key === 'cpmIds') {
      if (data['cpmIds'] instanceof Array) {
        data['cpmIds'].forEach((el, index) => {
          formData.append(`${key}[${index}].cid`, el.cid)
          formData.append(`${key}[${index}].pid`, el.pid)
          formData.append(`${key}[${index}].mid`, el.mid)
          // formData.append(`${key}[${index}].modelName`, el.modelName)
        });
      } else {
        formData.append('cpmIds', data['cpmIds'])
      }
    } else if (key === 'pictureFile') {
      formData.append('pictureFile', data[key][0]?.raw)
    }
    else if (['cids', 'pids'].includes(key)) {
      if (data[key] instanceof Array) {
        data[key].forEach((item, index) => {
          formData.append(`${key}[${index}]`, item)
        })
      } else {
        formData.append(`${key}`, data[key])
      }
    }
    else {
      if (paramsKeys.includes(key)) formData.append(key, data[key])
    }
  }
  return formData
}

// 获取协议
export const getAgentProtocolApi = (params?) => {
  return axiosInstance({
    method: 'get',
    url: '/api/category/getAgentProtocol',
    params
  })
}

// 新增CMS子代理商接口
export const addCMSAgentApi = data => {
  let formData = formatParams(data)
  return axiosInstance({
    method: 'post',
    url: '/api/category/addCmsAgent',
    data: formData,
    type: 'upload'
  })
}

// 编辑
export const editCMSAgentApi = data => {
  let formData = formatParams(data)
  // 加上id
  formData.append('id', data.id)
  return axiosInstance({
    method: 'post',
    url: '/api/category/editCmsAgent',
    data: formData,
    type: 'upload'
  })
}

// 删除子品牌
export const deleteSubBrandApi = data => {
  const { id } = data
  return axiosInstance({ method: 'delete', url: '/api/category/deleteCmsAgent', params: { id } })
}

// 获取子品牌详情信息
export const getSubBrandInfoApi = data => {
  const { id } = data
  return axiosInstance({ method: 'get', url: '/api/category/getCmsAgentInfoById', params: { id } })
}

// 获取运营模块选项
export const getAllOperatingModulesApi = params => axiosInstance({ method: 'get', url: '/api/category/getOperationModule', params })

// 点击子品牌，显示运营模块
export const getOperatingModuleByIdApi = params => axiosInstance({ method: 'get', url: '/api/category/getOperationModuleById', params })

// 获取主品牌信息
export const getMainAgentApi = (params) => {
  const { cid } = params
  return axiosInstance({
    method: 'get',
    url: '/api/category/getMainAgent',
    params: { cid }
  })
}

// 编辑主品牌名称
export const editMainAgentNameApi = (data) => {
  const { cid, name } = data
  return axiosInstance({
    method: 'post',
    url: '/api/category/editMainAgentName',
    data: { cid, name },
    // type: 'json'
  })
}

// 编辑大小logo
export const editMainAgentLogoApi = (data) => {
  let paramsKeys = ['logoFile', 'logoPath', 'cid', 'type']
  let formData = new FormData()
  for (let key in data) {
    if (key === 'logoFile') {
      formData.append('logoFile', data[key][0]?.raw)
    } else {
      if (paramsKeys.includes(key)) formData.append(key, data[key])
    }
  }
  return axiosInstance({
    method: 'post',
    url: '/api/category/editMainAgentLogo',
    data: formData,
    type: 'upload',
    noRepetition: true,
  })
}

/**======================================点播分类================================================== */

// 获取点播分类
export const getVodCategoryApi = params => {
  const { categoryId } = params
  return axiosInstance({ method: 'get', url: '/api/category/getVodCategory', params: { categoryId } })
}

// 添加点播分类
export const addVodCategoryApi = data => {
  const { categoryId, description, language, name, sequence, status, type } = data
  return axiosInstance({ method: 'post', url: '/api/category/addVodCategory', data: { categoryId, description, language, name, sequence, status, type }, type: 'json' })
}

// 编辑点播分类
export const editVodCategoryApi = data => {
  const { categoryId, description, language, name, sequence, status, type, id } = data
  return axiosInstance({ method: 'post', url: '/api/category/editVodCategory', data: { categoryId, description, language, name, sequence, status, type, id }, type: 'json' })
}

// 删除点播分类
export const delVodCategoryApi = data => {
  const { categoryId, ids } = data
  return axiosInstance({ method: 'delete', url: '/api/category/deleteVodCategory', data: { categoryId, ids }, type: 'json' })
}

// 节目数量更新
export const updateProgramSumApi = (data) => {
  const { categoryId } = data
  return axiosInstance({ method: 'post', url: '/api/category/updateProgramSum', data: { categoryId } })
}

// 点播内容列表: 按照名称排序
export const sortByNameApi = (data) => {
  const { categoryId, ids } = data
  return axiosInstance({ method: 'post', url: '/api/category/sortByName', data: { categoryId, ids }, type: 'json' })
}

// 产品运营下点播内容列表：获取添加点播中的列表
export const getAddVodInfoApi = (params) => {
  return axiosInstance({ method: 'get', url: '/api/category/getAddVodInfo', params, noRepetition: true })
}

// 获取点播分类下table item内容列表
export const getVodInfoListApi = (params) => {
  const { page, limit, sortType, sortByField, id, name } = params
  return axiosInstance({
    method: 'get',
    url: '/api/category/getVodInfoList',
    params: { page, limit, sortType, sortByField, id, name },
    noRepetition: true
  })
}

// 获取点播分类列表中ALL的内容列表
export const getVodAllInfoListApi = (params) => {
  const { page, limit, sortType, sortByField, id, name } = params
  return axiosInstance({
    method: 'get',
    url: '/api/category/getVodAllInfoList',
    params: { page, limit, sortType, sortByField, id, name },
    noRepetition: true,
  })
}

// 分类列表中类型ALL的移除
export const removeVodAllInfoApi = (data) => {
  return axiosInstance({
    method: 'delete',
    url: '/api/category/removeVodAllInfo',
    data,
    noRepetition: true,
    // arrayFormat: 'repeat',
    type: 'json'
  })
}

// 点播列表内容里面的移除
export const removeVodInfoApi = (data) => {
  const { categoryId, ids } = data
  return axiosInstance({
    method: 'delete',
    url: '/api/category/removeVodInfo',
    data: { categoryId, ids },
    noRepetition: true,
    // arrayFormat: 'repeat',
    type: 'json'
  })
}

// 运营管理点播内容列表内容里面的双击修改Sequence
export const changeSequenceVodInfoApi = (data) => {
  const { categoryId, id, sequence, sequenceBefore } = data
  return axiosInstance({
    method: 'post',
    url: '/api/category/changeSequenceVodInfo',
    data: { categoryId, id, sequence, sequenceBefore },
    noRepetition: true,
    type: 'json'
  })
}

// 获取点播列表中的id，方便添加点播，系列片回显
export const getVodInfoIdsApi = (params) => {
  const { categoryId, type } = params
  return axiosInstance({
    method: 'get',
    url: '/api/category/getVodInfoIds',
    params: { categoryId, type },
    noRepetition: true
  })
}

// 获取app风格下拉列表
export const getAppStyleOptionsApi = () => {
  return axiosInstance({
    method: 'get',
    url: '/api/category/option/appStyle',
  })
}

// 点播内容列表：添加点播
export const addVodInfoApi = (data) => {
  const { categoryId, idTypeList } = data
  return axiosInstance({
    method: 'post',
    url: '/api/category/addVodInfo',
    data: { categoryId, idTypeList },
    type: 'json',
    noRepetition: true
  })
}

// 点播内容列表：添加系列片
export const addProgramSetForOperationApi = (data) => {
  const { categoryId, setIds } = data
  return axiosInstance({
    method: 'post',
    url: '/api/category/addProgramSet',
    data: { categoryId, setIds },
    type: 'json',
    noRepetition: true
  })
}

// 点播内容列表内容付费设置
export const paymentSettingApi = (data) => {
  return axiosInstance({
    method: 'post',
    url: '/api/category/paymentSetting',
    data,
    type: 'json',
    noRepetition: true
  })
}

// 查询VodPlus方案
export const getVodPlusListApi = (params) => {
  const { agentId } = params
  return axiosInstance({
    method: 'get',
    url: '/api/vodplusTheme/getVodPlusList',
    params: { agentId },
    noRepetition: true
  })
}

// 添加VodPlus方案
export const addVodPlusApi = (data) => {
  const { name, status, operationPlanId, region, agentId } = data
  return axiosInstance({
    method: 'post',
    url: '/api/vodplusTheme/addVodPlus',
    data: { name, status, operationPlanId, region, agentId },
    // type: 'json',
    noRepetition: true
  })
}

// 编辑VodPlus方案
export const editVodPlusApi = (data) => {
  const { id, name, status, operationPlanId, region, agentId } = data
  return axiosInstance({
    method: 'post',
    url: '/api/vodplusTheme/editVodPlus',
    data: { id, name, status, operationPlanId, region, agentId },
    // type: 'json',
    noRepetition: true
  })
}

// 删除VodPlus方案
export const deleteVodPlusApi = (params) => {
  const { id } = params
  return axiosInstance({
    method: 'get',
    url: '/api/vodplusTheme/deleteVodPlus',
    params: { id },
    noRepetition: true,
    // arrayFormat: 'repeat'
  })
}

// 查询VodPlus运营方案主题
export const getOperationPlanThemeApi = (params) => {
  const { operationPlanId } = params
  return axiosInstance({
    method: 'get',
    url: '/api/vodplusTheme/getOperationPlanTheme',
    params: { operationPlanId },
    noRepetition: true,
  })
}

// 查询运营方案主题下某一项的内容
export const getOperationPlanThemeItemApi = (params) => {
  const { operationPlanThemeId, themeTemplateId, themeSubitemId, page, limit, name, status } = params
  return axiosInstance({
    method: 'get',
    url: '/api/vodplusTheme/getOperationPlanThemeItem',
    params: { operationPlanThemeId, themeTemplateId, themeSubitemId, page, limit, name, status },
    noRepetition: true,
  })
}

// 查询运营方案主题下全部内容
export const getOperationPlanThemeAllItemApi = (params) => {
  const { operationPlanThemeId } = params
  return axiosInstance({
    method: 'get',
    url: '/api/vodplusTheme/getOperationPlanThemeAllItem',
    params: { operationPlanThemeId },
    noRepetition: true,
  })
}

//  添加主题执行计划
export const addVodplusThemeItemPlanApi = (data) => {
  const { operationPlanThemeId, themeTemplateId, programList, themeSubitemId, region } = data
  return axiosInstance({
    method: 'post',
    url: '/api/vodplusTheme/addVodplusThemeItemPlan',
    data: { operationPlanThemeId, themeTemplateId, programList, themeSubitemId, region },
    noRepetition: true,
  })
}

// 编辑主题执行计划
export const editVodplusThemeItemPlanApi = (data) => {
  let formData = new FormData()
  for (let key in data) {
    if (key == 'imgFile') {
      formData.append(key, data[key]?.raw)
    } else {
      formData.append(key, data[key])
    }
  }
  return axiosInstance({
    method: 'post',
    url: '/api/vodplusTheme/editVodplusThemeItemPlan',
    data: formData,
    type: 'upload',
    noRepetition: true
  })
}

// 删除主题执行计划
export const deleteVodplusThemeItemPlanApi = (params) => {
  const { vodplusThemeItemId } = params
  return axiosInstance({
    method: 'get',
    url: '/api/vodplusTheme/deleteVodplusThemeItemPlan',
    params: { vodplusThemeItemId },
    noRepetition: true,
  })
}

// 运营计划上传图片
export const uploadVodplusThemeItemPictureApi = (data) => {
  // const { pictureList  } = data
  return axiosInstance({
    method: 'post',
    url: '/api/vodplusTheme/uploadVodplusThemeItemPicture',
    data,
    type: 'json',
    noRepetition: true,
  })
}

// 复制子推荐位
export const copyVodplusThemeSubitemApi = (data) => {
  const { themeSubitemId, region } = data
  return axiosInstance({
    method: 'post',
    url: '/api/vodplusTheme/copyVodplusThemeSubitem',
    data: { themeSubitemId, region },
    noRepetition: true,
  })
}

// 添加子推荐位
export const addVodplusThemeSubitemApi = (data) => {
  const { operationPlanThemeId, themeTemplateId, region } = data
  return axiosInstance({
    method: 'post',
    url: '/api/vodplusTheme/addVodplusThemeSubitem',
    data: { operationPlanThemeId, themeTemplateId, region },
    noRepetition: true,
  })
}

// 编辑子推荐位
export const editVodplusThemeSubitemApi = (data) => {
  const { themeSubitemId, region } = data
  return axiosInstance({
    method: 'post',
    url: '/api/vodplusTheme/editVodplusThemeSubitem',
    data: { themeSubitemId, region },
    noRepetition: true,
  })
}

// 删除子推荐位
export const deleteVodplusThemeSubitemApi = (params) => {
  const { themeSubitemId } = params
  return axiosInstance({
    method: 'get',
    url: '/api/vodplusTheme/deleteVodplusThemeSubitem',
    params: { themeSubitemId },
    noRepetition: true,
  })
}

// 添加运营主题
export const addOperationPlanBusinessThemeApi = (data) => {
  let paramsKeys = ['parentId', 'operationThemeName', 'status', 'no', 'runTimeStart', 'runTimeEnd', 'region', 'remarks', 'backgroundImgUrl', 'backgroundImgFile']
  let formData = new FormData()
  for (let key in data) {
    if (key === 'backgroundImgFile') {
      formData.append('backgroundImgFile', data[key][0]?.raw)
    } else {
      if (paramsKeys.includes(key)) formData.append(key, data[key])
    }
  }
  return axiosInstance({
    method: 'post',
    url: '/api/vodplusTheme/addOperationPlanBusinessTheme',
    data: formData,
    type: 'upload',
    noRepetition: true,
  })
}

// 编辑运营主题
export const editOperationPlanBusinessThemeApi = (data) => {
  let paramsKeys = ['id', 'operationThemeName', 'status', 'no', 'runTimeStart', 'runTimeEnd', 'region', 'remarks', 'backgroundImgUrl', 'backgroundImgFile', 'terminalCheck', 'noBefore', 'operationPlanId']
  let formData = new FormData()
  for (let key in data) {
    if (key === 'backgroundImgFile') {
      formData.append('backgroundImgFile', data[key][0]?.raw)
    } else {
      if (paramsKeys.includes(key)) formData.append(key, data[key])
    }
  }
  return axiosInstance({
    method: 'post',
    url: '/api/vodplusTheme/editOperationPlanBusinessTheme',
    data: formData,
    type: 'upload',
    noRepetition: true,
  })
}

// 删除运营主题
export const deleteOperationPlanBusinessThemeApi = (params) => {
  const { operationPlanBusinessThemeId } = params
  return axiosInstance({
    method: 'get',
    url: '/api/vodplusTheme/deleteOperationPlanBusinessTheme',
    params: { operationPlanBusinessThemeId },
    noRepetition: true,
  })
}

/**======================================运营方案管理================================================== */

// 获取运营方案管理列表
export const getOperationPlanApi = params => {
  return axiosInstance({ method: 'get', url: '/api/vodplusTheme/getOperationPlanList', params })
}

// 添加运营方案管理
export const addOperationPlanApi = data => {
  const { description, id, ids, name } = data
  return axiosInstance({ method: 'post', url: '/api/vodplusTheme/addOperationPlan', data: { description, id, ids, name }, type: 'json' })
}

// 编辑运营方案管理
export const editOperationPlanApi = data => {
  const { description, id, ids, name } = data
  return axiosInstance({ method: 'post', url: '/api/vodplusTheme/editOperationPlan', data: { description, id, ids, name }, type: 'json' })
}

// 删除运营方案管理
export const deleteOperationPlanApi = data => {
  const { id } = data
  return axiosInstance({ method: 'delete', url: '/api/vodplusTheme/deleteOperationPlan', data: { id } })
}

// 查看获取关联的主题
export const getRelationThemesApi = params => {
  const { id } = params
  return axiosInstance({ method: 'get', url: '/api/vodplusTheme/getRelationThemes', params: { id } })
}

// 获取文档的下载地址
export const getDocumentDownloadApi = (params?) => {
  return axiosInstance({ method: 'get', url: '/api/category/getDocumentDownload', params })
}

// 列表内容中导入电影
export const importMovieApi = data => {
  const { file, ids } = data
  return axiosInstance({ method: 'post', url: '/api/category/importMovie', data, type: 'upload', duration: 5000, timeout: 1800000 })
}

// 导入连续剧
export const importSeriesApi = data => {
  const { file, ids } = data
  return axiosInstance({ method: 'post', url: '/api/category/importSeries', data, type: 'upload', duration: 5000, timeout: 1800000 })
}

// 电视剧中导入续集
export const importSeriesEpisodeApi = data => {
  return axiosInstance({ method: 'post', url: '/api/category/importSeriesEpisode', data, type: 'upload', duration: 5000, timeout: 1800000 })
}

/**==========================================终端主品牌配置============================================= */

// 获取终端主品牌列表
export const getTreminalMainBrandListApi = (params) => axiosInstance({method: 'get', url:`/api/category/user/agent/switch/page`, params })

// 新增终端主品牌
export const addTreminalMainBrandApi = (data) => axiosInstance({method: 'post', url:`/api/category/user/agent/switch`, data, type:'json' })

// 删除终端主品牌
export const deleteTreminalMainBrandApi = (id) => axiosInstance({method: 'delete', url:`/api/category/user/agent/switch`, params: {id} })

// 更新终端主品牌
export const updateTreminalMainBrandApi = (data) => axiosInstance({method: 'put', url:`/api/category/user/agent/switch`, data, type:'json' })

// 获取主品牌选项列表
export const getMainBrandOptionsApi = () => axiosInstance({method: 'get', url:`/api/category/main/agent/options` })


/**==========================================云盘账户管理============================================= */

// 查询云盘账户列表
export const getCloudDiskApi = (params) => live_instance({method: 'get', url:`/vod-content/cloudDisk`,params })

// 更新云盘账户
export const updateCloudDiskApi = (params) => live_instance({method: 'put', url:`/vod-content/cloudDisk`,data:params,type: 'json' })

// 添加云盘账户
export const addCloudDiskApi = (params) => live_instance({method: 'post', url:`/vod-content/cloudDisk`,data:params,type: 'json' })

// 删除云盘账户
export const deleteCloudDiskApi = (params) => live_instance({method: 'delete', url:`/vod-content/cloudDisk`,params:params })

/**==========================================云盘链接管理============================================= */

// 查询云盘链接列表
export const getCloudLinkApi = (params) => live_instance({method: 'get', url:`/vod-content/cloudDisk/link`,params })

export const addCloudLinkApi = (params) => live_instance({method: 'post', url:`/vod-content/cloudDisk/link`,data:params,type: 'json' })

export const updateCloudLinkApi = (params) => live_instance({method: 'put', url:`/vod-content/cloudDisk/link`,data:params,type: 'json' })

export const deleteCloudLinkApi = (params) => live_instance({method: 'delete', url:`/vod-content/cloudDisk/link`,params:params,type: 'json' })

/**====================================================广告贴片============================================= */
// 获取贴片列表
export const getAdvertiseListApi = (params) => live_instance({method: 'get', url:`/ad-lite/ads`,params })

// 新增贴片
export const addAdvertiseApi = (data) => live_instance({method: 'post', url:`/ad-lite/ads`, data, type: 'json' })

// 编辑贴片参数
export const editAdvertiseParamsApi = (adId, data) => live_instance({method: 'put', url:`/ad-lite/ads/${adId}`, data, type: 'json' })

// 更新贴片的图片
export const updateAdvImageApi = (adId, data) => live_instance({method: 'put', url:`/ad-lite/ads/${adId}/file`, data, type: 'json' })

// 删除贴片
export const deleteAdvApi = (adId) => live_instance({method: 'delete', url:`/ad-lite/ads/${adId}` })







/**======================================== Sat-to-IP 节目分组 ========================================================= */
/** 获取 Sat-to-IP 分组列表 */
export const getSat2IpGroupListApi = () => live_instance({ method: 'get', url: '/live-operation/sat2ip/group/list' })

/** 新增 Sat-to-IP 分组 */
export const addSat2IpGroupApi = (data) => live_instance({ method: 'post', url: '/live-operation/sat2ip/group', data, type: 'json' })

/** 重命名 Sat-to-IP 分组 */
export const updateSat2IpGroupApi = (id, data) => live_instance({ method: 'put', url: `/live-operation/sat2ip/group/${id}`, data, type: 'json' })

/** 删除 Sat-to-IP 分组 */
export const deleteSat2IpGroupApi = (id) => live_instance({ method: 'delete', url: `/live-operation/sat2ip/group/${id}` })

/** 分页获取 Sat-to-IP 分组内频道 */
export const getSat2IpGroupChannelsApi = (id, params) => live_instance({ method: 'get', url: `/live-operation/sat2ip/group/${id}/channels`, params })

/** 按频道添加到 Sat-to-IP 分组 */
export const addSat2IpGroupChannelsApi = (id, data) => live_instance({ method: 'post', url: `/live-operation/sat2ip/group/${id}/channels`, data, type: 'json' })

/** 从 Sat-to-IP 分组批量移除频道 */
export const deleteSat2IpGroupChannelsApi = (id, data) => live_instance({ method: 'delete', url: `/live-operation/sat2ip/group/${id}/channels`, data, type: 'json' })

/** 按分类快照添加频道到 Sat-to-IP 分组 */
export const addSat2IpGroupChannelsByCategoryApi = (id, data) => live_instance({ method: 'post', url: `/live-operation/sat2ip/group/${id}/channels/by-category`, data, type: 'json' })